
export default {
  name: 'PostLarge',

  props: {
    post: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  }
}
